import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { Modal } from '@storable/canaveral-components';
import gql from 'graphql-tag';
import { sortFacilities } from '../../../../src/web/utils/distanceUtils';
import FacilitySelectTable from '../../../../src/web/components/FacilitySelectTable/FacilitySelectTable';
import Button from '../../components/stateless/Button';
import styles from './styles.scss';

const propTypes = {
  facilities: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.shape({
      latitude: PropTypes.string,
      longitude: PropTypes.string,
    }),
    pagePaths: PropTypes.arrayOf(PropTypes.shape({
      locale: PropTypes.string.isRequired,
    })),
  })).isRequired,
  enabledFacilities: PropTypes.shape({
    address: PropTypes.shape({
      latitude: PropTypes.string,
      longitude: PropTypes.string,
    }),
  }),
  onCancelEdit: PropTypes.func.isRequired,
  onFinishEdit: PropTypes.func.isRequired,
};

const defaultProps = {
  enabledFacilities: undefined,
};

class Editor extends React.Component {
  state = this.getState();

  getState() {
    const { facilities, enabledFacilities } = this.props;
    const state = {
      sortedFacilities: [],
      enabledFacilities: {},
    };

    if (enabledFacilities) {
      facilities.forEach((facility) => {
        state.enabledFacilities[facility.id] = enabledFacilities[facility.id] || false;
      });
    } else {
      facilities.forEach((facility) => {
        state.enabledFacilities[facility.id] = true;
      });
    }

    state.sortedFacilities = sortFacilities(facilities.filter(Boolean));

    return state;
  }

  handleChange = (id, { target }) => {
    const { enabledFacilities } = this.state;
    enabledFacilities[id] = target.checked || false;

    this.setState({
      enabledFacilities,
    });
  }

  handleSelectAllChange = ({ target }) => {
    const { sortedFacilities } = this.state;
    const enabledFacilities = {};
    sortedFacilities.forEach((facility) => {
      enabledFacilities[facility.id] = target.checked;
    });

    this.setState({
      enabledFacilities,
    });
  }

  handleSubmit = () => {
    const { onFinishEdit } = this.props;
    const { enabledFacilities } = this.state;

    onFinishEdit({
      enabledFacilities,
    });
  };

  render() {
    const { onCancelEdit } = this.props;
    const { sortedFacilities, enabledFacilities } = this.state;

    return (
      <Modal
        show
        onDismiss={onCancelEdit}
        aria-labelledby="facility-group-widget-editor"
      >
        <Form onSubmit={this.handleSubmit}>
          <Modal.Header>
            <Modal.Title id="facility-group-editor">Set Facility Group</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <b>Select Facilities</b>
            <FacilitySelectTable
              starStyling={styles.stars}
              enabledFacilities={enabledFacilities}
              liveFacilities={sortedFacilities}
              handleSelectAllChange={this.handleSelectAllChange}
              handleChange={this.handleChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="default" onClick={onCancelEdit}>Cancel</Button>
            <Button type="submit" variant="success">Apply</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

Editor.fragments = {
  facility: gql`
    fragment FacilityGroupWidgetEditor on Facility {
      ...FacilitySelectTableFacility
      currencySymbol
      phone
      applicableFeesEnabled
      settings {
        businessAddressDescription
      }
    }

    ${FacilitySelectTable.fragments.facility}
  `,
};

export default Editor;
